import React, { useState,useEffect } from "react";
import { useNavigate } from "react-router-dom";
import UploadImage from "./images";
import Addaproduct from "./addaproduct";
import Publish from "./preview/publish";
import ProductAvailable from "./productavailable";
import { Box, MenuItem, IconButton, Select, Card, CardContent, FormControl, Stepper, Step, Button, Typography,useMediaQuery, useTheme } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const steps = ["Product Category", "Product Details", "Images and Videos", "Availability & Cost", "Review & Submit"];

const ProductFlow = () => {
  const [activeStep, setActiveStep] = useState(0);
  const [categories, setCategories] = useState([]);
 const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
const navigate = useNavigate();
  const [formData, setFormData] = useState({
    categoryId: "", 
    categoryName: "", 
    title: "",
    description: "",
    location: "",
    price: "",
    images: [],
    availability: { noOfDays: 1, cost: 0 },
    promotion: { enabled: false, duration: 7, cost: 0 }
  });

  
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await fetch("https://daradservice.azurewebsites.net/api/P2PProducts/categories", {
          headers: { accept: "application/json" }
        });
  
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
  
        const result = await response.json(); // Get full response
        console.log("API Response:", result); // Debugging log
  
        if (result.status && Array.isArray(result.data)) {
          setCategories(result.data); // Update state with only the data array
          console.log("Fetched Categories:", result.data);
        } else {
          console.error("Unexpected API response format:", result);
        }
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };
  
    fetchCategories();
  }, []);
  


  const [errors, setErrors] = useState({}); 


  const validateForm = () => {
    let newErrors = {};
  
    if (activeStep === 0) {
      if (!formData.categoryId) {
        newErrors.categoryId = "Category ID is required";
      }
      if (!formData.categoryName) {
        newErrors.categoryName = "Category Name is required";
      }
    }
  
    if (activeStep === 1) {
      if (!formData.title?.trim()) newErrors.title = "Title is required";
      if (!formData.description?.trim()) newErrors.description = "Description is required";
      if (!formData.location?.trim()) newErrors.location = "Location is required";
  
      if (!formData.price) {
        newErrors.price = "Price is required";
      } else if (Number.isNaN(Number(formData.price))) {
        newErrors.price = "Price must be a valid number";
      }
    }
  
    if (activeStep === 2) {
      if (!Array.isArray(formData.images) || formData.images.length === 0) {
        newErrors.images = "At least one image is required";
      }
    }
  
   
  
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  
  


  const handleBack = () => setActiveStep((prevStep) => prevStep - 1);

  const handleNext = () => {
    if (validateForm()) {
      setActiveStep((prevStep) => prevStep + 1)
    }
  };



  return (
    <Box sx={{ width: "100%", p: isDesktop ? 4 : 2 }}>
 <div
  style={{
    display: isDesktop ? "block" : "flex",
    minHeight: "100px",
    justifyContent: "center",
  }}
>
  <Stepper activeStep={activeStep} orientation="horizontal">
    {steps.map((label, index) => (
      <Step key={label}>
       
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <div
              style={{
                width: 40,
                height: 40,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "20px",
                fontWeight: "bold",
                borderRadius: "50%",
                backgroundColor: index === activeStep ? "#121212" : "#F1F0F2",
                color: index === activeStep ? "white" : "#121212",
                marginBottom: 8,
              }}
            >
              {index + 1}
            </div>
            <span
              style={{
                fontSize: index === activeStep ? "18px" : "16px",
                fontWeight: index === activeStep ? "bold" : "normal",
                color: "black",
                textAlign: "center",
              }}
            >
              {label}
            </span>
          </div>
       
      </Step>
    ))}
  </Stepper>
</div>




  

      <Box sx={{ mt: 3 }}>
      <Box sx={{ width: "100%", p: isDesktop ? 4 : 2, position: "relative" }}>

      <IconButton 
  onClick={() => navigate("/product/marketplace")} 
  sx={{ 
    position: "absolute",
    top: 20,
    left: 20,
    color: "white", 
    background: "#5604F6 !important",  
    fontSize: "48px",
    borderRadius: "50px",
    zIndex: 1000,
    "&:hover": { background: "#4503D6 !important" } 
  }}
>
  <ArrowBackIcon />
</IconButton>
</Box>

        {activeStep === 0 && (
          <Card sx={{ maxWidth: isDesktop ? 500 : "100%", mx: "auto", mt: 5, p: 2, textAlign: "center", borderRadius: 3 }}>
            <CardContent>
              <Typography variant={isDesktop ? "h5" : "h6"}
        align="center"
        color="#5604F6"
        sx={{
          fontSize: isDesktop ? "36px" : "30px", 
          ...theme.typography.urbanist800
        }}
      >
                Select A Product Category
              </Typography>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1, mt: 1 }}>
                <Box sx={{ p: 1,  bgcolor: "#eee", borderRadius: 2, display: "inline-block" }}>
                  <Typography variant="caption" color="#5604F6" fontWeight={500}  sx={{ fontSize: isDesktop ? 18 : 20 }} >
                    Instructions
                  </Typography>  
                </Box>
                <Typography variant="body2" sx={{ color: "gray",  textAlign: "justify" ,  fontSize: isDesktop ? 18  : 20 }} >
                  Choose the most relevant category for your product to help buyers find it easily.
                </Typography>
              </Box>

              <Box sx={{ mt: 2, textAlign: "left" }}>
  <Typography variant="body2" fontWeight={500}  sx={{ fontSize: isDesktop ? 18 : 20 }} >Categories</Typography>
  
  <FormControl fullWidth sx={{ mt: 2 }} error={!!errors.categoryName}>
    <Select
      fullWidth
      value={formData?.categoryId}
      onChange={(e) => {
        const selectedCategory = categories.find((cat) => cat.id === parseInt(e.target.value));
        if (selectedCategory) {
          setFormData((prevData) => ({
            ...prevData,
            categoryId: selectedCategory.id,
            categoryName: selectedCategory.name,
          }));
        }
      }}
      sx={{
        borderRadius: "12px",
        backgroundColor: "#fff",
        height: "40px",
        fontSize: "18px",
        "& .MuiOutlinedInput-notchedOutline": { borderRadius: "12px" },
        "& .MuiSelect-select": { padding: "8px 12px" },
      }}
    >
      {categories.length > 0 ? (
        categories.map((category) => (
          <MenuItem key={category.id} value={category.id}>
            {category.name}
          </MenuItem>
        ))
      ) : (
        <MenuItem disabled>No categories available</MenuItem>
      )}
    </Select>

    {/* ✅ Display error message if validation fails */}
    {errors.categoryName && (
      <Typography variant="caption" color="error">
        {errors.categoryName}
      </Typography>
    )}
  </FormControl>
</Box>


              <Button
                variant="contained"
                sx={{
                  mt: 3,
                width: isDesktop ? "50%" : "100%",
                  borderRadius: "999px",
                  fontSize: isDesktop ? "16px" : "18px",
                  backgroundColor: "#5604F6 !important",
            color: "#EEE6FE !important",
                  textTransform: "none",
                  "&:hover": { backgroundColor: "#4b00c2" },
                }}
                onClick={handleNext}
               disabled={!formData?.categoryId}

              >
                {activeStep === steps.length - 2 ? "Review" : "Next →"}
              </Button>
            </CardContent>
          </Card>
        )}

        {activeStep === 1 && (
          <Addaproduct
            handleNext={handleNext}
            handleBack={handleBack}
            formData={formData}
            setFormData={setFormData}
            activeStep={activeStep}
            steps={steps}
            errors={errors}  
            setErrors={setErrors}
          />
        )}
        {activeStep === 2 && (
          <UploadImage
            handleNext={handleNext}
            handleBack={handleBack}
            formData={formData}
            setFormData={setFormData}
            activeStep={activeStep}
            steps={steps}
            errors={errors}  
            setErrors={setErrors}
          />
        )}
        {activeStep === 3 && (
          <ProductAvailable
            handleNext={handleNext}
            handleBack={handleBack}
            formData={formData}
            setFormData={setFormData}
            activeStep={activeStep}
            steps={steps}
          />
        )}
        {activeStep === 4 && 
        <Publish handleBack={handleBack} 
        formData={formData} activeStep={activeStep} steps={steps} />}

      </Box>
    </Box>
  );
};

export default ProductFlow;
